import { render, staticRenderFns } from "./Mammography.vue?vue&type=template&id=0e80cc29&scoped=true"
import script from "./Mammography.vue?vue&type=script&lang=js"
export * from "./Mammography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e80cc29",
  null
  
)

export default component.exports